// AUTO-GENERADO desde HorariosServicios19.08.26.xlsx (fuente de verdad). No editar a mano.
// Excluye la hoja IGUAZU-LAPLATA(NUEVO) (solo va en el marquee de PRÓXIMAMENTE).

export const LOCALITIES = [
  "9 de Julio",
  "Aristóbulo del Valle",
  "Bella Vista",
  "Bossetti",
  "Campana",
  "Candelaria",
  "Capioví",
  "Caraguatay",
  "Clorinda",
  "Colonia Magdalena",
  "Colonia Victoria",
  "Corrientes",
  "Cruce Varela",
  "Cuña Piru 1",
  "Cuña Piru 2",
  "Desmochado",
  "Dos De Mayo",
  "El Alcázar",
  "El Talar",
  "Eldorado",
  "Empedrado",
  "Escobar",
  "Esquina",
  "Formosa",
  "Garuhape",
  "Gdor. Roca",
  "Goya",
  "Gualeguaychú",
  "Hipólito Yrigoyen",
  "Ituzaingó",
  "Jardín América",
  "La Plata",
  "Lavalle",
  "Leandro N. Alem",
  "Libertad",
  "Loreto",
  "Los Teales",
  "Mansilla",
  "Mantilla",
  "Mercedes (Corrientes)",
  "Montecarlo",
  "Ñacanguazú",
  "Oberá",
  "Paraná",
  "Posadas",
  "Puerto Esperanza",
  "Puerto Iguazú",
  "Puerto Leoni",
  "Puerto Piray",
  "Puerto Rico",
  "Quilmes",
  "Resistencia",
  "Retiro",
  "Rosario",
  "Saladas",
  "Salto Encantado",
  "San Ignacio",
  "San Miguel",
  "San Vicente",
  "Santa Ana",
  "Santa Fe",
  "Santa Lucía",
  "Santa Rosa",
  "Santo Pipó",
  "Tabay",
  "Tatacuá",
  "Villa Olivari",
  "Wanda",
  "Zárate"
];

export const CONNECTIONS = {
  "Posadas": [
    {
      "to": "9 de Julio",
      "times": [
        "15:15"
      ]
    },
    {
      "to": "Aristóbulo del Valle",
      "times": [
        "10:45"
      ]
    },
    {
      "to": "Bella Vista",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Bossetti",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "15:15"
      ]
    },
    {
      "to": "Candelaria",
      "times": [
        "10:45"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "15:15"
      ]
    },
    {
      "to": "Cuña Piru 1",
      "times": [
        "10:45"
      ]
    },
    {
      "to": "Cuña Piru 2",
      "times": [
        "10:45"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Dos De Mayo",
      "times": [
        "10:45"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "15:15"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "15:15"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "10:45",
        "14:30"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "15:15"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "10:45",
        "14:30"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "14:30",
        "15:15"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "10:45",
        "14:30"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "15:15"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "07:30"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "14:30",
        "15:15"
      ]
    },
    {
      "to": "Los Teales",
      "times": [
        "10:45"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "15:15"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "15:15"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "10:45",
        "14:30"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "07:30"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "15:15"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "15:15"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "14:30",
        "15:15"
      ]
    },
    {
      "to": "Salto Encantado",
      "times": [
        "10:45"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "10:45",
        "14:30"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "14:30",
        "15:15"
      ]
    },
    {
      "to": "San Vicente",
      "times": [
        "10:45"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "10:45",
        "14:30"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "14:30",
        "15:15"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "10:45",
        "14:30"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "14:30",
        "15:15"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "14:30",
        "15:15"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "14:30"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "15:15"
      ]
    }
  ],
  "Ituzaingó": [
    {
      "to": "9 de Julio",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Bella Vista",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "06:15"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "15:45",
        "16:30"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "06:15"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "06:15",
        "06:45"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "15:45",
        "16:30"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "15:45",
        "16:30"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "15:45",
        "16:30"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "15:45",
        "16:30"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "15:45",
        "16:30"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "16:30"
      ]
    }
  ],
  "Loreto": [
    {
      "to": "9 de Julio",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Bella Vista",
      "times": [
        "16:50"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "16:50"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "16:50"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "16:50"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "05:10",
        "05:45"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "05:10"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "05:10"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "16:50"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "05:10",
        "05:45"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "16:50"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "16:50",
        "17:30"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "16:50",
        "17:30"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "16:50"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "16:50"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "16:50",
        "17:30"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "16:50",
        "17:30"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "16:50",
        "17:30"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "05:10"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "17:30"
      ]
    }
  ],
  "San Miguel": [
    {
      "to": "9 de Julio",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "Bella Vista",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "04:30",
        "05:15"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "04:30"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "04:30",
        "05:15"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "04:30"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "04:30",
        "05:15"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "17:30",
        "18:00"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "17:30",
        "18:00"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "17:30",
        "18:00"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "17:30",
        "18:00"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "04:30"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "18:00"
      ]
    }
  ],
  "Santa Rosa": [
    {
      "to": "9 de Julio",
      "times": [
        "18:45"
      ]
    },
    {
      "to": "Bella Vista",
      "times": [
        "18:20"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "18:45"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "18:45"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "18:20"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "18:45"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "18:45"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "18:20"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "18:20"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "18:45"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "03:40",
        "04:30"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "18:45"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "03:40"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "03:40",
        "04:30"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "18:45"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "18:45"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "03:40"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "18:20"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "03:40",
        "04:30"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "18:45"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "18:45"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "18:20"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "18:20",
        "18:45"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "03:40",
        "04:30"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "18:20"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "18:20"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "18:20",
        "18:45"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "18:20",
        "18:45"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "03:40"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "18:45"
      ]
    }
  ],
  "Tabay": [
    {
      "to": "9 de Julio",
      "times": [
        "19:05"
      ]
    },
    {
      "to": "Bella Vista",
      "times": [
        "18:40"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "19:05"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "19:05"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "18:40"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "19:05"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "19:05"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "18:40"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "18:40"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "19:05"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "03:20",
        "04:05"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "19:05"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "03:20"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "03:20",
        "04:05"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "19:05"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "19:05"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "03:20"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "18:40"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "03:20",
        "04:05"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "19:05"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "19:05"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "18:40"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "18:40",
        "19:05"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "03:20",
        "04:05"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "18:40"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "18:40"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "03:20",
        "04:05"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "18:40",
        "19:05"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "03:20"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "19:05"
      ]
    }
  ],
  "Tatacuá": [
    {
      "to": "9 de Julio",
      "times": [
        "19:15"
      ]
    },
    {
      "to": "Bella Vista",
      "times": [
        "18:50"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "19:15"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "19:15"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "18:50"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "19:15"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "19:15"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "18:50"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "18:50"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "19:15"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "03:10",
        "03:55"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "19:15"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "03:10"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "03:10",
        "03:55"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "19:15"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "19:15"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "03:10"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "18:50"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "03:10",
        "03:55"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "19:15"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "19:15"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "18:50"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "18:50",
        "19:15"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "03:10",
        "03:55"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "18:50"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "18:50"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "03:10",
        "03:55"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "03:10",
        "03:55"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "03:10"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "19:15"
      ]
    }
  ],
  "Saladas": [
    {
      "to": "9 de Julio",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Bella Vista",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "03:00",
        "03:45"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "03:00"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "03:00",
        "03:45"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "03:00"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "03:00",
        "03:45"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "03:00",
        "03:45"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "03:00",
        "03:45"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "03:00",
        "03:45"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "03:00",
        "03:45"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "03:00"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "19:30"
      ]
    }
  ],
  "Mantilla": [
    {
      "to": "9 de Julio",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "03:00"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "03:00"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "03:00"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "03:00"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "03:00"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "03:00"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "03:00"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "03:00"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "20:15"
      ]
    }
  ],
  "9 de Julio": [
    {
      "to": "Campana",
      "times": [
        "20:45"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "20:45"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "20:45"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "20:45"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "20:45"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "02:45"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "20:45"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "02:45"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "02:45"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "20:45"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "02:45"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "20:45"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "20:45"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "02:45"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "02:45"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "02:45"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "02:45"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "02:45"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "20:45"
      ]
    }
  ],
  "Mercedes (Corrientes)": [
    {
      "to": "9 de Julio",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "22:00"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "22:00"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "22:00"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "22:00"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "22:00"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "22:00"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "22:00"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "22:00"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "22:00"
      ]
    }
  ],
  "Gualeguaychú": [
    {
      "to": "9 de Julio",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "02:00"
      ]
    }
  ],
  "Zárate": [
    {
      "to": "9 de Julio",
      "times": [
        "18:30"
      ]
    },
    {
      "to": "Bella Vista",
      "times": [
        "16:56"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "04:30",
        "07:02"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "16:56"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "16:56"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "04:30",
        "07:02"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "04:30",
        "07:02"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "16:56"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "04:30",
        "07:02"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "16:56"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "16:56"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "16:56"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "18:30"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "18:30"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "04:30",
        "07:02"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "18:30"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "16:56"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "18:30"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "18:30"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "18:30"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "04:30",
        "07:02"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "16:56"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "04:30",
        "07:02"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "18:30"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "18:30"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "16:56"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "18:30"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "18:30"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "18:30"
      ]
    }
  ],
  "Campana": [
    {
      "to": "9 de Julio",
      "times": [
        "18:10"
      ]
    },
    {
      "to": "Bella Vista",
      "times": [
        "16:35"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "16:35"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "16:35"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "04:50",
        "07:25"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "04:50",
        "07:25"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "16:35"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "04:50",
        "07:25"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "16:35"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "16:35"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "16:35"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "18:10"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "18:10"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "04:50",
        "07:25"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "18:10"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "16:35"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "18:10"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "18:10"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "18:10"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "04:50",
        "07:25"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "16:35"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "04:50",
        "07:25"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "18:10"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "18:10"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "16:35"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "18:10"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "18:10"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "18:10"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "16:35",
        "18:10"
      ]
    }
  ],
  "Escobar": [
    {
      "to": "9 de Julio",
      "times": [
        "17:50"
      ]
    },
    {
      "to": "Bella Vista",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "16:05",
        "17:50"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "05:10",
        "07:55"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "05:10",
        "07:55"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "17:50"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "17:50"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "05:10",
        "07:55"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "17:50"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "17:50"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "17:50"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "17:50"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "05:10",
        "07:55"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "05:10",
        "07:55"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "17:50"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "17:50"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "17:50"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "17:50"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "17:50"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "16:05",
        "17:50"
      ]
    }
  ],
  "El Talar": [
    {
      "to": "9 de Julio",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Bella Vista",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "16:00",
        "17:30"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "05:30",
        "08:15"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "16:00",
        "17:30"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "05:30",
        "08:15"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "05:30",
        "08:15"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "05:30",
        "08:15"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "16:00",
        "17:30"
      ]
    }
  ],
  "Retiro": [
    {
      "to": "9 de Julio",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Bella Vista",
      "times": [
        "15:00"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "15:00",
        "16:45"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "15:00"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "15:00"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "06:00",
        "09:00"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "15:00",
        "16:45"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "15:00"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "15:00",
        "16:45"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "15:00"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "15:00"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "15:00"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "06:00",
        "09:00"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "15:00"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "06:00",
        "09:00"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "15:00"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "15:00"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "15:00",
        "16:45"
      ]
    }
  ],
  "Quilmes": [
    {
      "to": "9 de Julio",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Bella Vista",
      "times": [
        "14:00"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "14:00",
        "16:05"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "14:00"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "14:00"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "06:45",
        "10:00"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "14:00",
        "16:05"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "14:00"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "14:00",
        "16:05"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "14:00"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "14:00"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "14:00"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "06:45",
        "10:00"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "14:00"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "14:00"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "14:00",
        "16:05"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "14:00"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "14:00",
        "16:05"
      ]
    }
  ],
  "Cruce Varela": [
    {
      "to": "9 de Julio",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Bella Vista",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "13:45",
        "15:45"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "13:45",
        "15:45"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "13:45",
        "15:45"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "07:15",
        "10:15"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "13:45",
        "15:45"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "13:45",
        "15:45"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "13:45",
        "15:45"
      ]
    }
  ],
  "La Plata": [
    {
      "to": "9 de Julio",
      "times": [
        "14:45"
      ]
    },
    {
      "to": "Bella Vista",
      "times": [
        "13:00"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "13:00",
        "14:45"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "13:00"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "13:00"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "13:00",
        "14:45"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "13:00",
        "14:45"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "13:00"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "13:00",
        "14:45"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "13:00"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "13:00"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "13:00"
      ]
    },
    {
      "to": "Gualeguaychú",
      "times": [
        "14:45"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "14:45"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "14:45"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "13:00"
      ]
    },
    {
      "to": "Mantilla",
      "times": [
        "14:45"
      ]
    },
    {
      "to": "Mercedes (Corrientes)",
      "times": [
        "14:45"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "14:45"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "13:00",
        "14:45"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "13:00"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "13:00",
        "14:45"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "14:45"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "14:45"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "13:00"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "14:45"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "14:45"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "14:45"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "13:00",
        "14:45"
      ]
    }
  ],
  "Clorinda": [
    {
      "to": "Bella Vista",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Lavalle",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "13:45"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "13:45"
      ]
    }
  ],
  "Formosa": [
    {
      "to": "Bella Vista",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "07:00"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Lavalle",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "15:45"
      ]
    }
  ],
  "Mansilla": [
    {
      "to": "Bella Vista",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "06:00"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "06:00"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Lavalle",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "16:45"
      ]
    }
  ],
  "Resistencia": [
    {
      "to": "Bella Vista",
      "times": [
        "18:15"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "18:15"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "04:45"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "18:15"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "18:15"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "18:15"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "18:15"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "18:15"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "18:15"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "04:45"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "18:15"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "18:15"
      ]
    },
    {
      "to": "Lavalle",
      "times": [
        "18:15"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "04:45"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "18:15"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "18:15"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "18:15"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "18:15"
      ]
    }
  ],
  "Corrientes": [
    {
      "to": "Bella Vista",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "04:10"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "04:10"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Lavalle",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "04:10"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "04:10"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "19:00"
      ]
    }
  ],
  "Empedrado": [
    {
      "to": "Bella Vista",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "03:15"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "03:15"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "03:15"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Lavalle",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "03:15"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "03:15"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "19:45"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "19:45"
      ]
    }
  ],
  "Bella Vista": [
    {
      "to": "Campana",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "02:15"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "02:15"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "20:00"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "02:15"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "20:00",
        "21:10"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "02:15"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "20:00",
        "21:10"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Lavalle",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "02:15"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "20:00"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "02:15"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "20:00"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "20:00"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "20:00",
        "21:10"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "21:10"
      ]
    }
  ],
  "Santa Lucía": [
    {
      "to": "Bella Vista",
      "times": [
        "01:00",
        "01:45"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "21:45"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "01:45"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "01:45"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "21:45"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "01:00"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "21:45"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "01:45"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "21:45"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "21:00",
        "21:45"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "01:45"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "21:00",
        "21:45"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "01:00"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "21:45"
      ]
    },
    {
      "to": "Lavalle",
      "times": [
        "21:45"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "01:00"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "01:00"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "01:45"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "01:00"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "21:00"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "01:00"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "21:45"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "01:45"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "21:45"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "21:00"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "01:00"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "01:00"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "21:00"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "01:00"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "01:00"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "01:00"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "01:00"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "21:45"
      ]
    }
  ],
  "Lavalle": [
    {
      "to": "Campana",
      "times": [
        "21:52"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "21:52"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "21:52"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "21:52"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "21:52"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "21:52"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "21:52"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "21:52"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "21:52"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "21:52"
      ]
    }
  ],
  "Goya": [
    {
      "to": "Bella Vista",
      "times": [
        "00:30",
        "01:05"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "22:30"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "01:05"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "01:05"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "22:30"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "00:30"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "22:30"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "01:05"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "22:30"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "21:30",
        "22:30"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "01:05"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "00:30"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "22:30"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "00:30"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "00:30"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "01:05"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "00:30"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "21:30"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "00:30"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "22:30"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "01:05"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "22:30"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "21:30"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "00:30"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "00:30"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "21:30"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "00:30",
        "01:05"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "00:30"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "00:30"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "00:30"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "00:30"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "22:30"
      ]
    }
  ],
  "Esquina": [
    {
      "to": "Bella Vista",
      "times": [
        "23:00",
        "23:30"
      ]
    },
    {
      "to": "Campana",
      "times": [
        "23:57"
      ]
    },
    {
      "to": "Clorinda",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Corrientes",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Cruce Varela",
      "times": [
        "23:57"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "El Talar",
      "times": [
        "23:57"
      ]
    },
    {
      "to": "Empedrado",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Escobar",
      "times": [
        "23:57"
      ]
    },
    {
      "to": "Formosa",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "23:00",
        "23:30"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "La Plata",
      "times": [
        "23:57"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Mansilla",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Quilmes",
      "times": [
        "23:57"
      ]
    },
    {
      "to": "Resistencia",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Retiro",
      "times": [
        "23:57"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "23:00",
        "23:30"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Zárate",
      "times": [
        "23:57"
      ]
    }
  ],
  "Oberá": [
    {
      "to": "Bella Vista",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "12:40"
      ]
    }
  ],
  "Leandro N. Alem": [
    {
      "to": "Bella Vista",
      "times": [
        "13:10"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "13:10"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "13:10"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "13:10"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "13:10"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "13:10"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "08:30"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "13:10"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "13:10"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "13:10"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "13:10"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "13:10"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "13:10"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "13:10"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "13:10"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "13:10"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "13:10"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "13:10"
      ]
    }
  ],
  "Villa Olivari": [
    {
      "to": "Bella Vista",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "05:45"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "05:45"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "05:45"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "05:45"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "16:15"
      ]
    }
  ],
  "Desmochado": [
    {
      "to": "Bella Vista",
      "times": [
        "01:30"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "20:30"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "20:30"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "01:30"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "01:30"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "01:30"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "01:30"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "20:30"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "01:30"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "20:30"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "01:30"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "01:30"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "20:30"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "20:30"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "01:30"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "01:30"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "01:30"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "01:30"
      ]
    }
  ],
  "Paraná": [
    {
      "to": "Bella Vista",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "02:00"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "20:15"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "20:15"
      ]
    }
  ],
  "Santa Fe": [
    {
      "to": "Bella Vista",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Rosario",
      "times": [
        "02:45"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "19:30"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "19:30"
      ]
    }
  ],
  "Rosario": [
    {
      "to": "Bella Vista",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "Desmochado",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "Esquina",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "Goya",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "Ituzaingó",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "Leandro N. Alem",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "Loreto",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "Oberá",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "Paraná",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "Saladas",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "San Miguel",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "Santa Fe",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "Santa Lucía",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "Santa Rosa",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "Tabay",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "Tatacuá",
      "times": [
        "17:00"
      ]
    },
    {
      "to": "Villa Olivari",
      "times": [
        "17:00"
      ]
    }
  ],
  "Candelaria": [
    {
      "to": "Aristóbulo del Valle",
      "times": [
        "11:15"
      ]
    },
    {
      "to": "Cuña Piru 1",
      "times": [
        "11:15"
      ]
    },
    {
      "to": "Cuña Piru 2",
      "times": [
        "11:15"
      ]
    },
    {
      "to": "Dos De Mayo",
      "times": [
        "11:15"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "11:15"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "11:15"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "11:15"
      ]
    },
    {
      "to": "Los Teales",
      "times": [
        "11:15"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "11:15"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "18:35"
      ]
    },
    {
      "to": "Salto Encantado",
      "times": [
        "11:15"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "11:15"
      ]
    },
    {
      "to": "San Vicente",
      "times": [
        "11:15"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "11:15"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "11:15"
      ]
    }
  ],
  "Santa Ana": [
    {
      "to": "Aristóbulo del Valle",
      "times": [
        "11:35"
      ]
    },
    {
      "to": "Bossetti",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Candelaria",
      "times": [
        "18:15"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Cuña Piru 1",
      "times": [
        "11:35"
      ]
    },
    {
      "to": "Cuña Piru 2",
      "times": [
        "11:35"
      ]
    },
    {
      "to": "Dos De Mayo",
      "times": [
        "11:35"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "11:35",
        "15:20"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "11:35",
        "15:20"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "11:35",
        "15:20"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Los Teales",
      "times": [
        "11:35"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "11:35",
        "15:20"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "01:15",
        "18:15"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Salto Encantado",
      "times": [
        "11:35"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "11:35",
        "15:20"
      ]
    },
    {
      "to": "San Vicente",
      "times": [
        "11:35"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "11:35",
        "15:20"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "15:20"
      ]
    }
  ],
  "San Ignacio": [
    {
      "to": "Aristóbulo del Valle",
      "times": [
        "11:50"
      ]
    },
    {
      "to": "Bossetti",
      "times": [
        "15:40"
      ]
    },
    {
      "to": "Candelaria",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "15:40"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "15:40"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "15:40"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "15:40"
      ]
    },
    {
      "to": "Cuña Piru 1",
      "times": [
        "11:50"
      ]
    },
    {
      "to": "Cuña Piru 2",
      "times": [
        "11:50"
      ]
    },
    {
      "to": "Dos De Mayo",
      "times": [
        "11:50"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "15:40"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "15:40"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "15:40"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "11:50",
        "15:40"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "11:50",
        "15:40"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "11:50",
        "15:40"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "15:40"
      ]
    },
    {
      "to": "Los Teales",
      "times": [
        "11:50"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "15:40"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "11:50",
        "15:40"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "00:55",
        "18:00"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "15:40"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "15:40"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "15:40"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "15:40"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "15:40"
      ]
    },
    {
      "to": "Salto Encantado",
      "times": [
        "11:50"
      ]
    },
    {
      "to": "San Vicente",
      "times": [
        "11:50"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "00:55",
        "18:00"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "11:50",
        "15:40"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "15:40"
      ]
    }
  ],
  "Gdor. Roca": [
    {
      "to": "Aristóbulo del Valle",
      "times": [
        "12:00"
      ]
    },
    {
      "to": "Bossetti",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Candelaria",
      "times": [
        "17:50"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Cuña Piru 1",
      "times": [
        "12:00"
      ]
    },
    {
      "to": "Cuña Piru 2",
      "times": [
        "12:00"
      ]
    },
    {
      "to": "Dos De Mayo",
      "times": [
        "12:00"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "12:00",
        "15:45"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "12:00",
        "15:45"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Los Teales",
      "times": [
        "12:00"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "12:00",
        "15:45"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "00:50",
        "17:50"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "15:45"
      ]
    },
    {
      "to": "Salto Encantado",
      "times": [
        "12:00"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "00:50",
        "17:50"
      ]
    },
    {
      "to": "San Vicente",
      "times": [
        "12:00"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "00:50",
        "17:50"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "12:00",
        "15:45"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "15:45"
      ]
    }
  ],
  "Santo Pipó": [
    {
      "to": "Aristóbulo del Valle",
      "times": [
        "12:10"
      ]
    },
    {
      "to": "Bossetti",
      "times": [
        "15:50"
      ]
    },
    {
      "to": "Candelaria",
      "times": [
        "17:40"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "15:50"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "15:50"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "15:50"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "15:50"
      ]
    },
    {
      "to": "Cuña Piru 1",
      "times": [
        "12:10"
      ]
    },
    {
      "to": "Cuña Piru 2",
      "times": [
        "12:10"
      ]
    },
    {
      "to": "Dos De Mayo",
      "times": [
        "12:10"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "15:50"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "15:50"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "15:50"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "00:45",
        "17:40"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "12:10",
        "15:50"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "12:10",
        "15:50"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "15:50"
      ]
    },
    {
      "to": "Los Teales",
      "times": [
        "12:10"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "15:50"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "12:10",
        "15:50"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "00:45",
        "17:40"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "15:50"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "15:50"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "15:50"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "15:50"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "15:50"
      ]
    },
    {
      "to": "Salto Encantado",
      "times": [
        "12:10"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "00:45",
        "17:40"
      ]
    },
    {
      "to": "San Vicente",
      "times": [
        "12:10"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "00:45",
        "17:40"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "15:50"
      ]
    }
  ],
  "Ñacanguazú": [
    {
      "to": "Aristóbulo del Valle",
      "times": [
        "12:20"
      ]
    },
    {
      "to": "Bossetti",
      "times": [
        "15:55"
      ]
    },
    {
      "to": "Candelaria",
      "times": [
        "17:30"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "15:55"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "15:55"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "15:55"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "15:55"
      ]
    },
    {
      "to": "Cuña Piru 1",
      "times": [
        "12:20"
      ]
    },
    {
      "to": "Cuña Piru 2",
      "times": [
        "12:20"
      ]
    },
    {
      "to": "Dos De Mayo",
      "times": [
        "12:20"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "15:55"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "15:55"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "15:55"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "00:40",
        "17:30"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "12:20",
        "15:55"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "12:20",
        "15:55"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "15:55"
      ]
    },
    {
      "to": "Los Teales",
      "times": [
        "12:20"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "15:55"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "00:40",
        "17:30"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "15:55"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "15:55"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "15:55"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "15:55"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "15:55"
      ]
    },
    {
      "to": "Salto Encantado",
      "times": [
        "12:20"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "00:40",
        "17:30"
      ]
    },
    {
      "to": "San Vicente",
      "times": [
        "12:20"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "00:40",
        "17:30"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "00:40",
        "17:30"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "15:55"
      ]
    }
  ],
  "Hipólito Yrigoyen": [
    {
      "to": "Aristóbulo del Valle",
      "times": [
        "12:25"
      ]
    },
    {
      "to": "Bossetti",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Candelaria",
      "times": [
        "17:25"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Cuña Piru 1",
      "times": [
        "12:25"
      ]
    },
    {
      "to": "Cuña Piru 2",
      "times": [
        "12:25"
      ]
    },
    {
      "to": "Dos De Mayo",
      "times": [
        "12:25"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "00:30",
        "17:25"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "12:25",
        "16:05"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Los Teales",
      "times": [
        "12:25"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "00:30",
        "17:25"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "00:30",
        "17:25"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "16:05"
      ]
    },
    {
      "to": "Salto Encantado",
      "times": [
        "12:25"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "00:30",
        "17:25"
      ]
    },
    {
      "to": "San Vicente",
      "times": [
        "12:25"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "00:30",
        "17:25"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "00:30",
        "17:25"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "16:05"
      ]
    }
  ],
  "Jardín América": [
    {
      "to": "Aristóbulo del Valle",
      "times": [
        "12:30"
      ]
    },
    {
      "to": "Bossetti",
      "times": [
        "16:10"
      ]
    },
    {
      "to": "Candelaria",
      "times": [
        "17:20"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "16:10"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "16:10"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "16:10"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "16:10"
      ]
    },
    {
      "to": "Cuña Piru 1",
      "times": [
        "12:30"
      ]
    },
    {
      "to": "Cuña Piru 2",
      "times": [
        "12:30"
      ]
    },
    {
      "to": "Dos De Mayo",
      "times": [
        "12:30"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "16:10"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "16:10"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "16:10"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "00:25",
        "17:20"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "00:25",
        "17:20"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "16:10"
      ]
    },
    {
      "to": "Los Teales",
      "times": [
        "12:30"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "16:10"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "00:25",
        "17:20"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "00:25",
        "17:20"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "16:10"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "16:10"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "16:10"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "16:10"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "16:10"
      ]
    },
    {
      "to": "Salto Encantado",
      "times": [
        "12:30"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "00:25",
        "17:20"
      ]
    },
    {
      "to": "San Vicente",
      "times": [
        "12:30"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "00:25",
        "17:20"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "00:25",
        "17:20"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "16:10"
      ]
    }
  ],
  "Los Teales": [
    {
      "to": "Aristóbulo del Valle",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Candelaria",
      "times": [
        "17:10"
      ]
    },
    {
      "to": "Cuña Piru 1",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Cuña Piru 2",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Dos De Mayo",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "17:10"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "17:10"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "17:10"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "17:10"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "17:10"
      ]
    },
    {
      "to": "Salto Encantado",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "17:10"
      ]
    },
    {
      "to": "San Vicente",
      "times": [
        "12:40"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "17:10"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "17:10"
      ]
    }
  ],
  "Cuña Piru 2": [
    {
      "to": "Aristóbulo del Valle",
      "times": [
        "12:45"
      ]
    },
    {
      "to": "Candelaria",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Cuña Piru 1",
      "times": [
        "12:45"
      ]
    },
    {
      "to": "Dos De Mayo",
      "times": [
        "12:45"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Los Teales",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Salto Encantado",
      "times": [
        "12:45"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "San Vicente",
      "times": [
        "12:45"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "17:05"
      ]
    }
  ],
  "Cuña Piru 1": [
    {
      "to": "Aristóbulo del Valle",
      "times": [
        "12:55"
      ]
    },
    {
      "to": "Candelaria",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Cuña Piru 2",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Dos De Mayo",
      "times": [
        "12:55"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Los Teales",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Salto Encantado",
      "times": [
        "12:55"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "San Vicente",
      "times": [
        "12:55"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "16:55"
      ]
    }
  ],
  "Aristóbulo del Valle": [
    {
      "to": "Candelaria",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Cuña Piru 1",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Cuña Piru 2",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Dos De Mayo",
      "times": [
        "13:20"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Los Teales",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Salto Encantado",
      "times": [
        "13:20"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "San Vicente",
      "times": [
        "13:20"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "16:30"
      ]
    }
  ],
  "Salto Encantado": [
    {
      "to": "Aristóbulo del Valle",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Candelaria",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Cuña Piru 1",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Cuña Piru 2",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Dos De Mayo",
      "times": [
        "13:30"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Los Teales",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "San Vicente",
      "times": [
        "13:30"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "16:15"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "16:15"
      ]
    }
  ],
  "Dos De Mayo": [
    {
      "to": "Aristóbulo del Valle",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Candelaria",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Cuña Piru 1",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Cuña Piru 2",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Los Teales",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Salto Encantado",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "San Vicente",
      "times": [
        "13:50"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "16:00"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "16:00"
      ]
    }
  ],
  "San Vicente": [
    {
      "to": "Aristóbulo del Valle",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Candelaria",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Cuña Piru 1",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Cuña Piru 2",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Dos De Mayo",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Los Teales",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Salto Encantado",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "15:20"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "15:20"
      ]
    }
  ],
  "Puerto Leoni": [
    {
      "to": "Bossetti",
      "times": [
        "16:20"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "16:20"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "16:20"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "16:20"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "16:20"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "16:20"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "16:20"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "16:20"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "00:15"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "00:15"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "00:15"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "16:20"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "16:20"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "00:15"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "00:15"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "16:20"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "16:20"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "16:20"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "16:20"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "00:15"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "00:15"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "00:15"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "16:20"
      ]
    }
  ],
  "Capioví": [
    {
      "to": "Bossetti",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "00:05"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "00:05"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "00:05"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "00:05"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "00:05"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "00:05"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "16:30"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "00:05"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "00:05"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "00:05"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "16:30"
      ]
    }
  ],
  "Puerto Rico": [
    {
      "to": "Bossetti",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "23:50"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "23:50"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "23:50"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "23:50"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "23:50"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "23:50"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "23:50"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "16:45"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "23:50"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "23:50"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "23:50"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "16:45"
      ]
    }
  ],
  "Garuhape": [
    {
      "to": "Bossetti",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "23:40"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "23:40"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "23:40"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "23:40"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "23:40"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "23:40"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "23:40"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "16:55"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "23:40"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "23:40"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "23:40"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "23:40"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "16:55"
      ]
    }
  ],
  "El Alcázar": [
    {
      "to": "Bossetti",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "17:05"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "23:30"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "17:05"
      ]
    }
  ],
  "Caraguatay": [
    {
      "to": "Bossetti",
      "times": [
        "17:15"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "23:20"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "17:15"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "17:15"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "23:20"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "17:15"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "23:20"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "23:20"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "23:20"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "23:20"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "17:15"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "17:15"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "23:20"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "23:20"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "17:15"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "17:15"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "23:20"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "17:15"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "23:20"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "23:20"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "23:20"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "23:20"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "17:15"
      ]
    }
  ],
  "Montecarlo": [
    {
      "to": "Bossetti",
      "times": [
        "17:25"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "23:10"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "23:10"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "17:25"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "17:25"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "23:10"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "17:25"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "23:10"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "23:10"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "23:10"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "23:10"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "17:25"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "23:10"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "23:10"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "17:25"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "17:25"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "23:10"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "17:25"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "23:10"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "23:10"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "23:10"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "23:10"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "17:25"
      ]
    }
  ],
  "Puerto Piray": [
    {
      "to": "Bossetti",
      "times": [
        "17:35"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "17:35"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "17:35"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "17:35"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "17:35"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "17:35"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "17:35"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "23:00"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "17:35"
      ]
    }
  ],
  "Eldorado": [
    {
      "to": "Bossetti",
      "times": [
        "17:45"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "22:50"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "22:50"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "17:45"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "17:45"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "22:50"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "22:50"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "22:50"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "22:50"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "22:50"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "17:45"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "22:50"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "22:50"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "22:50"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "17:45"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "17:45"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "22:50"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "22:50"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "22:50"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "22:50"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "22:50"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "22:50"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "17:45"
      ]
    }
  ],
  "Colonia Victoria": [
    {
      "to": "Bossetti",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "18:00"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "22:35"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "18:00"
      ]
    }
  ],
  "Colonia Magdalena": [
    {
      "to": "Bossetti",
      "times": [
        "18:30"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "18:30"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "18:30"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "18:30"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "22:05"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "18:30"
      ]
    }
  ],
  "Puerto Esperanza": [
    {
      "to": "Bossetti",
      "times": [
        "18:45"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "18:45"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "18:45"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "21:50"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "18:45"
      ]
    }
  ],
  "Wanda": [
    {
      "to": "Bossetti",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "19:00"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "21:35"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "21:35"
      ]
    }
  ],
  "Libertad": [
    {
      "to": "Bossetti",
      "times": [
        "19:10"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "19:10"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "21:25"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "21:25"
      ]
    }
  ],
  "Bossetti": [
    {
      "to": "Capioví",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Puerto Iguazú",
      "times": [
        "19:25"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "21:10"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "21:10"
      ]
    }
  ],
  "Puerto Iguazú": [
    {
      "to": "Bossetti",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Capioví",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Caraguatay",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Colonia Magdalena",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Colonia Victoria",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "El Alcázar",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Eldorado",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Garuhape",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Gdor. Roca",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Hipólito Yrigoyen",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Jardín América",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Libertad",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Montecarlo",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Ñacanguazú",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Posadas",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Puerto Esperanza",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Puerto Leoni",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Puerto Piray",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Puerto Rico",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "San Ignacio",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Santa Ana",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Santo Pipó",
      "times": [
        "20:40"
      ]
    },
    {
      "to": "Wanda",
      "times": [
        "20:40"
      ]
    }
  ]
};

export const destinationsFrom = (loc) => CONNECTIONS[loc] || [];
export const originsWithService = () => LOCALITIES.filter((l) => (CONNECTIONS[l] || []).length > 0);
